// Admin sign-in gate. Credentials are checked client-side for the prototype —
// swap `verify` for POST /admin/session before this goes anywhere real.

import React, { useState } from "react";
import { Button, inputStyle } from "./ui.jsx";

const ADMIN_USER = "boardiq";
const ADMIN_PASS = "password-boardiq";

const labelStyle = {
  font: "600 10px/1 var(--bq-font-display)",
  letterSpacing: ".14em",
  textTransform: "uppercase",
  color: "var(--muted2)",
};

export default function AdminLogin({ onSuccess }) {
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [error, setError] = useState("");

  const submit = () => {
    if (user.trim() === ADMIN_USER && pass === ADMIN_PASS) {
      setError("");
      onSuccess({ username: user.trim() });
    } else {
      setPass("");
      setError("That username and password don't match.");
    }
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") submit();
  };

  return (
    <div style={{ flex: 1, minHeight: 0, display: "flex", alignItems: "center", justifyContent: "center", padding: "clamp(16px, 4vw, 40px)" }}>
      <div style={{ width: "100%", maxWidth: 380, display: "flex", flexDirection: "column", gap: 20 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 16, height: 16, background: "var(--accent)", flex: "none" }} />
          <span style={{ font: "800 19px/1 var(--bq-font-display)", letterSpacing: "-0.02em" }}>BoardIQ</span>
        </div>

        <div style={{ borderTop: "2px solid var(--ink)", paddingTop: 16 }}>
          <div style={{ ...labelStyle, color: "var(--accentDeep)", marginBottom: 6 }}>Restricted</div>
          <h1 style={{ margin: "0 0 6px", font: "800 clamp(24px, 4vw, 32px)/1 var(--bq-font-display)", letterSpacing: "-0.03em" }}>
            Administrator sign in
          </h1>
          <p style={{ margin: 0, font: "400 13px/1.5 var(--bq-font-body)", color: "var(--body)", textWrap: "pretty" }}>
            Portfolio administration for every association on the account.
          </p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <label htmlFor="admin-user" style={labelStyle}>Username</label>
          <input
            id="admin-user"
            value={user}
            autoComplete="username"
            placeholder="boardiq"
            onChange={(e) => { setUser(e.target.value); setError(""); }}
            onKeyDown={onKeyDown}
            style={inputStyle}
          />
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <label htmlFor="admin-pass" style={labelStyle}>Password</label>
          <input
            id="admin-pass"
            type="password"
            value={pass}
            autoComplete="current-password"
            placeholder="••••••••"
            onChange={(e) => { setPass(e.target.value); setError(""); }}
            onKeyDown={onKeyDown}
            style={inputStyle}
          />
        </div>

        {error && (
          <div
            role="alert"
            style={{
              borderLeft: "3px solid var(--accent)",
              background: "var(--accentTint)",
              padding: "10px 12px",
              font: "500 12.5px/1.4 var(--bq-font-body)",
              color: "var(--accentDeep)",
            }}
          >
            {error}
          </div>
        )}

        <Button onClick={submit} style={{ minHeight: 48, padding: "14px 16px" }}>Sign in</Button>

        <a
          href="#/"
          style={{ ...labelStyle, letterSpacing: ".1em", textDecoration: "none", color: "var(--muted2)" }}
        >
          ← Back to BoardIQ
        </a>
      </div>
    </div>
  );
}
